import { IInvestorProfileChipProps } from "../components/complex/InvestorProfileChip/types"

const mockClients: {
        clientName: string,
        clientInvestProfile: IInvestorProfileChipProps['profile'],
        clientAmount: string,
        portfolio?: string,
    }[] = [
    {
        clientName: "Maria",
        clientAmount: "R$: 1.000.010",
        clientInvestProfile: "conservative",
    },
    {
        clientName: "Lucas",
        clientAmount: "R$: 1.000.009",
        clientInvestProfile: "balanced",
    },
    {
        clientName: "Henrique",
        clientAmount: "R$: 1.000.008",
        clientInvestProfile: "sophisticated",
    },
]

const mockMessages = [
    {
        text: "hello world",
        answer: false,
        context: undefined,
        timestamp: new Date()
    },
    {
        text: "hello world",
        answer: true,
        context: undefined,
        timestamp: new Date()
    },
    {
        text: "hello world",
        answer: false,
        context: undefined,
        timestamp: new Date()
    }
]

const mockCommitments = {
    "number_of_commitments": 5,
    "total_days_with_events": 3,
    "commitments": [
      {
        "due_date": "2025-11-18",
        "clients": [
          {
            "client": {
              "name": "Christine Anderson",
              "account": 50470823174088,
              "perfil": "SOFISTICADO"
            },
            "allocation_details": {
              "positionDate": "2025-11-17",
              "allocations": [
                { "strategy": "Alternativo", "value": 0 },
                { "strategy": "Inflacao", "value": 15022.82 },
                { "strategy": "Internacional", "value": 0 },
                { "strategy": "Multimercado", "value": 0 },
                { "strategy": "NaoClassificada", "value": 0 },
                { "strategy": "NaoInformada", "value": 76.38 },
                { "strategy": "Posfixado", "value": 0 },
                { "strategy": "Prefixado", "value": 0 },
                { "strategy": "RendaFixaGlobal", "value": 0 },
                { "strategy": "RendaVariavel", "value": 82810.6 },
                { "strategy": "RendaVariavelGlobal", "value": 0 },
                { "strategy": "RetornoAbsolutoMm", "value": 21442.15 }
              ],
              "allocationTotal": 119351.95
            },
            "last_updated_date": "2025-11-17",
            "produto_a_vencer": {
              "nameProduct": "CRA - 20251118",
              "strategy": "RETORNO ABSOLUTO MM"
            },
            "net_amount": 679.4867245745883,
            "net_worth": 119351.95334316252,
            "liquidityEventResolution": false
          }
        ]
      },
      {
        "due_date": "2025-11-20",
        "clients": [
          {
            "client": {
              "name": "Jimmy Coleman",
              "account": 447783472864,
              "perfil": "CONSERVADOR"
            },
            "allocation_details": {
              "positionDate": "2025-11-17",
              "allocations": [
                { "strategy": "Alternativo", "value": 201109.66 },
                { "strategy": "Inflacao", "value": 311729.02 },
                { "strategy": "Internacional", "value": 0 },
                { "strategy": "Multimercado", "value": 0 },
                { "strategy": "NaoClassificada", "value": 0 },
                { "strategy": "NaoInformada", "value": 0 },
                { "strategy": "Posfixado", "value": 1106495.81 },
                { "strategy": "Prefixado", "value": 0 },
                { "strategy": "RendaFixaGlobal", "value": 0 },
                { "strategy": "RendaVariavel", "value": 0 },
                { "strategy": "RendaVariavelGlobal", "value": 0 },
                { "strategy": "RetornoAbsolutoMm", "value": 0 }
              ],
              "allocationTotal": 1619334.49
            },
            "last_updated_date": "2025-11-17",
            "produto_a_vencer": {
              "nameProduct": "CDB - 20251120"
            },
            "net_amount": 27299.195996106017,
            "net_worth": 1619334.4910549556,
            "liquidityEventResolution": false
          }
        ]
      },
      {
        "due_date": "2025-11-21",
        "clients": [
          {
            "client": {
              "name": "Nancy Nguyen",
              "account": 22758116865288,
              "perfil": "CONSERVADOR"
            },
            "allocation_details": null,
            "last_updated_date": "2025-11-17",
            "produto_a_vencer": {
              "nameProduct": "CDB - 20251121"
            },
            "net_amount": 7130.717464992223,
            "net_worth": 947148.2055871458,
            "liquidityEventResolution": false
          },
          {
            "client": {
              "name": "Carlos Erickson",
              "account": 69542165356498,
              "perfil": "INDEFINIDO"
            },
            "allocation_details": {
              "positionDate": "2025-11-17",
              "allocations": [
                { "strategy": "Alternativo", "value": 0 },
                { "strategy": "Inflacao", "value": 40404.49 },
                { "strategy": "Internacional", "value": 0 },
                { "strategy": "Multimercado", "value": 0 },
                { "strategy": "NaoClassificada", "value": 0 },
                { "strategy": "NaoInformada", "value": 2687.85 },
                { "strategy": "Posfixado", "value": 87618.24 },
                { "strategy": "Prefixado", "value": 1889.14 },
                { "strategy": "RendaFixaGlobal", "value": 0 },
                { "strategy": "RendaVariavel", "value": 8055.14 },
                { "strategy": "RendaVariavelGlobal", "value": 0 },
                { "strategy": "RetornoAbsolutoMm", "value": 0 }
              ],
              "allocationTotal": 140654.86
            },
            "last_updated_date": "2025-11-17",
            "produto_a_vencer": {
              "nameProduct": "LCI - 20251121"
            },
            "net_amount": 3239.8332266123048,
            "net_worth": 140654.8641417012,
            "liquidityEventResolution": false
          },
          {
            "client": {
              "name": "Chad Brown",
              "account": 3360305163394,
              "perfil": "CONSERVADOR"
            },
            "allocation_details": {
              "positionDate": "2025-11-17",
              "allocations": [
                { "strategy": "Alternativo", "value": 0 },
                { "strategy": "Inflacao", "value": 0 },
                { "strategy": "Internacional", "value": 0 },
                { "strategy": "Multimercado", "value": 0 },
                { "strategy": "NaoClassificada", "value": 0 },
                { "strategy": "NaoInformada", "value": 0 },
                { "strategy": "Posfixado", "value": 99406.1 },
                { "strategy": "Prefixado", "value": 0 },
                { "strategy": "RendaFixaGlobal", "value": 0 },
                { "strategy": "RendaVariavel", "value": 0 },
                { "strategy": "RendaVariavelGlobal", "value": 0 },
                { "strategy": "RetornoAbsolutoMm", "value": 0 }
              ],
              "allocationTotal": 99406.1
            },
            "last_updated_date": "2025-11-17",
            "produto_a_vencer": {
              "nameProduct": "CDB - 20251121"
            },
            "net_amount": 35251.70092606958,
            "net_worth": 99406.09960966227,
            "liquidityEventResolution": false
          }
        ]
      }
    ],
    "reference_portfolios": [
      {
        "perfil": "CONSERVADOR",
        "posfixado": 0.48,
        "prefixado": 0.0,
        "inflacao": 0.25,
        "retorno_absoluto_mm": 0.06,
        "renda_variavel": 0.0,
        "alternativo": 0.01,
        "renda_fixa_global": 0.15,
        "renda_variavel_global": 0.05
      },
      {
        "perfil": "MODERADO",
        "posfixado": 0.43,
        "prefixado": 0.0,
        "inflacao": 0.25,
        "retorno_absoluto_mm": 0.08,
        "renda_variavel": 0.02,
        "alternativo": 0.02,
        "renda_fixa_global": 0.10,
        "renda_variavel_global": 0.10
      },
      {
        "perfil": "SOFISTICADO",
        "posfixado": 0.38,
        "prefixado": 0.0,
        "inflacao": 0.25,
        "retorno_absoluto_mm": 0.10,
        "renda_variavel": 0.04,
        "alternativo": 0.03,
        "renda_fixa_global": 0.05,
        "renda_variavel_global": 0.15
      }
    ]
  }

export {mockClients, mockMessages, mockCommitments}